import { V2BookingStatus } from '@/api/clients/ohip';

export function isBookingCancelled(status: V2BookingStatus) {
  return ['CANCELLED', 'CANCELLED_BY_PMS', 'CANCELLED_BY_USER'].includes(
    status
  );
}

export function isBookingConfirmed(status: V2BookingStatus) {
  return ['CONFIRMED', 'COMPLETED'].includes(status);
}

export function isBookingPendingConfirmation(status: V2BookingStatus) {
  return status === 'PAYMENT_RECEIVED_PENDING_CONFIRMATION';
}
